/** @format */

import React from "react";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Stack,
  Button,
  List,
  ListItemButton,
  ListItemText,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/styles";
import ListItemIcon from "@mui/material/ListItemIcon";
import ExpandMore from "@mui/icons-material/ExpandMoreRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import Popover from "@mui/material/Popover";
import { Box } from "@mui/system";
import LogoP5 from "../../img/P5Desktop.svg";
import LogoP5Mobile from "../../img/Logo P5 Mobile.png";
import LenguageMenu from "./LanguageMenu";
import { useEffect } from "react";

const useStyles = (theme) => ({
  container: {
    boxShadow: "none",
    backgroundColor: theme.palette.white.secondary,
    color: theme.palette.blue.main,
    fontFamily: theme.typography.anaHeim.regular,
  },
  button: {
    color: theme.palette.blue.main,
    fontFamily: theme.typography.montserrat.semibold,
  },
  popoverBtn: {
    fontFamily: theme.typography.montserrat.semibold,
    bg: theme.palette.white.main,
    color: theme.palette.blue.main,
  },
  popOverList: {
    fontFamily: theme.typography.montserrat.regular,
    margin: "1rem",
  },
});

const mainMenu = [
  {
    to: "/",
    text: "Home",
  },
  {
    text: "Etapas",
    stages: [
      "/intro",
      "/challenge",
      "/bootcamp",
      "/bootcamp/javascript",
      "/bootcamp/salesforce",
    ],
  },
  {
    to: "/nosotros",
    text: "Nosotros",
  },
  {
    to: "/faqs",
    text: "Preguntas Frecuentes",
  },
];

const menu = [
  {
    to: "/intro",
    text: "1- CURSO INTRODUCTORIO",
  },
  {
    to: "/challenge",
    text: "2- CODING CHALLENGE",
  },
  {
    to: "/bootcamp",
    text: "3- CODING BOOTCAMP",
  },
];

const subMenu = [
  {
    to: "/bootcamp/javascript",
    text: "JavaScript Bootcamp",
  },
  {
    to: "/bootcamp/salesforce",
    text: "Salesforce Bootcamp",
  },
];

const NavBarDesktop = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openSub, setOpenSub] = useState(false);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const tab = "\u00A0";

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenSub(!openSub);
  };

  const handleClickSub = () => {
    setOpenSub(!openSub);
  };

  const isTablet = useMediaQuery("(max-width:1200px)");

  const theme = useTheme();
  const classes = useStyles(theme);

  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    setOpenSub(false);
    setAnchorEl(null);
  }, [pathname]);

  return (
    <>
      <AppBar position="static" sx={classes.container}>
        <Toolbar
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            textalign: "center",
            zIndex: 1,
          }}
        >
          {!isTablet ? (
            <Box sx={{ height: "8rem" }} component={Link} to={"/"}>
              <img
                src={LogoP5}
                alt="Plataforma 5 Logo"
                title="Plataforma 5 Logo"
                style={{ padding: "1.8rem", height: "4rem" }}
              />
            </Box>
          ) : (
            <Box sx={{ height: "8rem" }} component={Link} to={"/"}>
              <img
                src={LogoP5Mobile}
                alt="Plataforma 5 Logo"
                title="Plataforma 5 Logo"
                style={{ padding: "1.8rem", height: "4rem" }}
              />
            </Box>
          )}

          <Stack direction="row" spacing={3}>
            {mainMenu.map(({ to, text, stages }) => (
              <Button
                key={text}
                component={to ? Link : null}
                to={to}
                sx={{
                  ...classes.button,
                  borderRadius: "0",
                  borderBottom:
                    (pathname === to || stages?.includes(pathname)) &&
                    `2px solid ${theme.palette.red.main}`,
                }}
                {...(to
                  ? {}
                  : {
                      onClick: handleClick,
                      "aria-controls": open ? "stages-menu" : undefined,
                      "aria-haspopup": "true",
                      "aria-expanded": open ? "true" : undefined,
                    })}
              >
                {text}
              </Button>
            ))}

            <Button
              component={Link}
              to={"/aplica"}
              sx={{
                margin: "0",
                padding: ".5rem 1.5rem .5rem 1.5rem",
                borderRadius: "25px",
                textTransform: "none",
                bgcolor: theme.palette.blue.secondary,
                color: theme.palette.white.main,
                alignText: "center",
                fontFamily: theme.typography.montserrat.semibold,
                "&:hover": {
                  color: theme.palette.blue.secondary,
                },
              }}
              textalign="center"
            >
              APLICAR{tab}
              <span role="img" aria-label="Rocket">
                🚀
              </span>
            </Button>

            <Button sx={classes.button}>
              <LenguageMenu />
            </Button>
          </Stack>

          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            sx={{
              boxShadow: "none",
            }}
            PaperProps={{
              elevation: 0,
              sx: {
                boxShadow: "none",
                backgroundColor: theme.palette.white.secondary,
                mt: "2.2rem",
                maxWidth: "100%",
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                borderBottomLeftRadius: 25,
                borderBottomRightRadius: 25,
              },
            }}
          >
            <List
              component="div"
              disablePadding
              direction="column"
              sx={classes.popoverBtn}
            >
              {menu.map(({ to, text }) => (
                <ListItemButton
                  key={text}
                  sx={{ pl: 4 }}
                  component={to ? Link : null}
                  to={to}
                  onClick={!to ? handleClickSub : null}
                >
                  <ListItemText
                    primary={text}
                    sx={classes.popOverList}
                    primaryTypographyProps={{ fontSize: ".8rem" }}
                  />
                  {!to && <ExpandMore />}
                </ListItemButton>
              ))}
              <List component="div" disablePadding>
                {subMenu.map(({ to, text }) => (
                  <ListItemButton
                    key={to}
                    sx={{ pl: 4, ml: 2 }}
                    component={Link}
                    to={to}
                  >
                    <ListItemIcon style={{ minWidth: "2rem" }}>
                      <ArrowForwardIosRoundedIcon
                        style={{
                          height: ".6rem",
                          color: theme.palette.blue.main,
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{ fontSize: ".8rem" }}
                      primary={text}
                      sx={{
                        color: theme.palette.blue.main,
                        margin: "1rem",
                      }}
                    />
                  </ListItemButton>
                ))}
              </List>
            </List>
          </Popover>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default NavBarDesktop;
